module.exports = __webpack_public_path__ + "static/img/picture_5.b5109ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/picture_5.png
// module id = B6nH
// module chunks = 0